module.exports = __webpack_public_path__ + "img/tres-puntos-active.e9099a47.svg";